
import contractImageUK from '../../assets/png/contractNumber.png';
import contractImageDE from '../../assets/png/contractNumberDE.png';
import contractImageES from '../../assets/png/contractNumberES.png';
import BackArrow from '../../assets/svg/BackArrow.svg';
import JDFLogo from '../../assets/svg/jdf_logo.svg';
import i18n from '../../i18n';
import Smartlook from '../../utils/smartlook';
import {
  callNumber,
  sendCustomDataNR,
  sendScreenViewNR,
} from '../../utils/util';

import {
  Accordion,
  AccordionDetails,
  AccordionItem,
  AccordionSummary,
  AccordionTitle,
  Button,
  Link,
} from '@deere/fuel-react';
import React from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import './helpFaq.css';

const HelpFaq = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const country =
    location.state?.selectedCountry ||
    localStorage.getItem('countryCode') ||
    'gb';
  const returnPath = location.state?.returnPath || '/verification';

  const [currentAccordion, setCurrentAccordion] = React.useState(0);

  const showFAQMenu = () => {
    navigate(returnPath, {replace: true});
  };

  const t = i18n.t;
  React.useEffect(() => {
    sendScreenViewNR('FAQ');
    Smartlook.navigation('FAQ');
    sendCustomDataNR(
      'FAQ',
      sessionStorage.getItem('trace-id'),
      localStorage.getItem('countryCode'),
      null,
      'LANDED_FAQ'
    );
  }, []);

  function callHandler(e) {
    e.preventDefault();
    window.open(`tel:${t('CONTACT_NUMBER')}`);
    callNumber(t('CONTACT_NUMBER'));
  }

  const forgotUniqueID = () => {
    sendCustomDataNR(
      'FetchCustomerID',
      sessionStorage.getItem('trace-id'),
      localStorage.getItem('countryCode'),
      null,
      'FetchCustomerID_Clicked'
    );
    navigate('/get-customer-id', {
      state: {
        selectedCountry: country,
        returnPath: '/verification',
      },
    });
  };

  function handleAccordionClick(index) {
    const newIndex = currentAccordion === index ? undefined : index;
    setCurrentAccordion(newIndex);
  }

  const helpQuestions = [
    {
      question: t('FAQ_Q1'),
      answer: t('FAQ_A1'),
    },
    {
      question: t('FAQ_Q2'),
      answer: t('FAQ_A2'),
    },
    {
      question: t('FAQ_Q3'),
      answer: t('FAQ_A3'),
      element:
        country === 'gb' ? (
          <img src={contractImageUK} alt="contract-number" />
        ) : country === 'es' ? (
          <img src={contractImageES} alt="contract-number" />
        ) : country === 'de' ? (
          <img src={contractImageDE} alt="contract-number" />
        ) : null,
    },
    {
      question: t('FAQ_Q4'),
      actionButton: (
        <Button
          type="button"
          variant="primary"
          size="small"
          className="callNow-btn"
          onClick={callHandler}
        >
          {t('CALL_NOW')}
        </Button>
      ),
      hasEmail: true,
      disable: country === 'es' || country === 'pt',
    },
    {
      question: t('FAQ_Q8'),
      answer: t('FAQ_A8'),
      actionButton: (
        <Link onClick={forgotUniqueID}>{t('GET_UNIQUE_ID')}</Link>
      ),
      disable: country === 'es' || country === 'pt',
    },
    {
      question: t('FAQ_Q6'),
      actionButton: (
        <Button
          type="button"
          variant="primary"
          size="small"
          className="callNow-btn"
          onClick={callHandler}
        >
          {t('CALL_NOW')}
        </Button>
      ),
      hasSupportEmail: true,
    },
  ];

  function contactNumberGen(item) {
    if (country === 'gb') {
      return item.hasSupportEmail ? (
        <div>
          For support, please call us{' '}
          <span
            onClick={() => callNumber(t('CUSTOMER_CARE_NUMBER'))}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                callNumber(t('CUSTOMER_CARE_NUMBER'));
              }
            }}
          >
            <Link href={`tel:${t('CUSTOMER_CARE_NUMBER')}`}>
              {t('CUSTOMER_CARE_NUMBER')}
            </Link>
          </span>{' '}
          or send email to{' '}
          <a
            href="mailto:UKJDFCustomerCare@JohnDeere.com"
            className="help-link"
          >
            UKJDFCustomerCare@JohnDeere.com
          </a>{' '}
          (lines are open Mon-Fri from 8:30 to 16:30)
        </div>
      ) : (
        <div>
          Customer ID is your unique digital idententification number. Your
          Customer ID has been sent to you via registered mail. If you have not
          received it, please call us{' '}
          <span>
            <Link
              href={`tel:${t('CUSTOMER_CARE_NUMBER')}`}
              onClick={() => callNumber(t('CUSTOMER_CARE_NUMBER'))}
            >
              {t('CUSTOMER_CARE_NUMBER')}
            </Link>
          </span>{' '}
          or send email to{' '}
          <a
            href="mailto:UKJDFCustomerCare@JohnDeere.com"
            className="help-link"
          >
            UKJDFCustomerCare@JohnDeere.com
          </a>{' '}
          (lines are open Mon-Fri from 8:30 to 16:30)
        </div>
      );
    }

    if (country === 'de') {
      return item.hasSupportEmail ? (
        <div>
          Wenn Sie Unterstützung benötigen, senden Sie bitte eine E-Mail an{' '}
          <a
            href="mailto:5LLUXCustomerCare@JohnDeere.com"
            className="help-link"
          >
            5LLUXCustomerCare@JohnDeere.com
          </a>{' '}
          oder klicken Sie auf die Schaltfläche „Jetzt anrufen“ (die Leitungen
          sind Mo-Fr von 8:30 bis 16:30 Uhr besetzt).
        </div>
      ) : (
        <div>
          Die Kundennummer ist Ihre eindeutige digitale Identifikationsnummer.
          Ihre Kundennummer wurde Ihnen per Post zugesandt. Wenn Sie sie nicht
          erhalten haben, können Sie uns unter der Rufnummer{' '}
          <span>
            <Link
              href={`tel:${t('CUSTOMER_CARE_NUMBER')}`}
              onClick={() => callNumber(t('CUSTOMER_CARE_NUMBER'))}
            >
              {t('CUSTOMER_CARE_NUMBER')}
            </Link>
          </span>{' '}
          kontaktieren oder eine E-Mail an{' '}
          <a
            href="mailto:5LLUXCustomerCare@JohnDeere.com"
            className="help-link"
          >
            5LLUXCustomerCare@JohnDeere.com
          </a>{' '}
          senden (die Leitungen sind Mo-Fr von 8:30 bis 16:30 Uhr besetzt).
        </div>
      );
    }

    if (country === 'es') {
      return (
        <div>
          Por favor, comprueba que estés introduciendo tu nombre exactamente
          igual que está escrito en tu NIF. Si aún así tienes problemas para
          completar el registro en MYFinancial, puedes contactar con nosotros
          llamando al teléfono{' '}
          <span>
            <Link
              href={`tel:${t('CUSTOMER_CARE_NUMBER')}`}
              onClick={() => callNumber(t('CUSTOMER_CARE_NUMBER'))}
            >
              {t('CUSTOMER_CARE_NUMBER')}
            </Link>
          </span>{' '}
          o enviando un e-mail a{' '}
          <a href="mailto:JDFClientes@johndeere.com" className="help-link">
            JDFClientes@johndeere.com
          </a>{' '}
        </div>
      );
    }

    if (country === 'pt') {
      return (
        <div>
          Por favor, verifique se está a introduzir o seu nome exatamente como
          está escrito no seu NIF. Se ainda tiver problemas para completar o
          registo no MYFinancial, pode contactar-nos ligando para o número{' '}
          <span
            onClick={() => callNumber(t('CUSTOMER_CARE_NUMBER'))}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                callNumber(t('CUSTOMER_CARE_NUMBER'));
              }
            }}
          >
            {' '}
            <Link href={`tel:${t('CUSTOMER_CARE_NUMBER')}`}>
              {t('CUSTOMER_CARE_NUMBER')}
            </Link>
          </span>{' '}
          ou enviando um e-mail para{' '}
          <a
            href="mailto:5LLUXCustomerCare@JohnDeere.com"
            className="help-link"
          >
            5LLUXCustomerCare@JohnDeere.com
          </a>{' '}
        </div>
      );
    }
  }

  const showFAQHandler = () => {
    showFAQMenu();
  };

  return (
    <>
      <header
        id="SecurityVerificationCustomHeader"
        data-testid="securityVerificationHeader"
      >
        <div className="jdf-logo">
          <img src={JDFLogo} alt="JDF Logo" />
        </div>
      </header>
      <div className="help-wrapper" id="helpWrapper">
        <div className="help-topBar">
          <div className="back-wrapper" onClick={showFAQHandler}>
            <img src={BackArrow} alt="Back Arrow" />
            {t('BACK')}
          </div>
        </div>
        <div className="help-body">
          <div className="help-heading">{t('FAQ')}</div>
          <div className="help-subheading">{t('POPULAR_QUESTIONS')}</div>
          <div className="help-wrapper-header">
            <Accordion id="help-questions">
              {helpQuestions.map((item, index) => {
                return item.disable ? null : (
                  <AccordionItem
                    id="question-container-index"
                    key={item.question}
                    data-testid={'question-container-' + index}
                    expanded={index === currentAccordion}
                  >
                    <AccordionSummary
                      onClick={() => handleAccordionClick(index)}
                    >
                      <AccordionTitle>{item.question}</AccordionTitle>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="help-details">
                        {item.hasEmail || item.hasSupportEmail ? (
                          contactNumberGen(item)
                        ) : (
                          <div className="help-answer">{item?.answer}</div>
                        )}
                        <div className="help-image">{item.element ?? null}</div>
                        <div className="help-action-btn">
                          {item.actionButton ?? null}
                        </div>
                      </div>
                    </AccordionDetails>
                  </AccordionItem>
                );
              })}
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};
export default HelpFaq;
